export const sideBarOptions = {
	primaryOptions: [
		{
			icon: "check_circle",
			color: "green",
			label: "1 - Mensuração",
			id: "mensuration"
		},
		{
			icon: "cancel",
			color: "red", 
			label: "2 - Gestão",
			id: "menagement"
		},
		{
			icon: "cancel",
			color: "red",
			label: "3 - Engajamento e Comunicação",
			id: "comunication"
		}
	],
	secondaryOptions: [
		{	
			icon: "home",
			label: "Início",
		},
		{	
			icon: "work",
			label: "Relatório",
			className: " "
		},
		{
			icon: "flag",
			label: "Sobre o Sistema",
			className: "",
			id: "aboutUs"
		},
		{
			icon: "lock",
			label: "Senha"
		},
		{
			icon: "person",
			label: "Sair"
		}
	]
};
















// WEBPACK FOOTER //
// src/models/lib/sideBarOptionsModel.js